import { render, staticRenderFns } from "./PriorityRenderer.vue?vue&type=template&id=4998bd10&v-if=valueIsDefined&"
import script from "./PriorityRenderer.vue?vue&type=script&lang=js&"
export * from "./PriorityRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports